import { SimNaoEnum } from 'components/form'
import { createValidator, ErrorObject, required } from 'util/validation'

import {
  CONSULTA_SEGUIMENTO_NAO_PARA_TODOS_VALIDATION_MESSAGE,
  isStatusValid,
} from '../../validator-consultaSeguimento'
import { ConsultaSeguimentoPergunta16Model } from './model-consultaSeguimentoPergunta16'
import {
  hasPergunta16ExemplosFalhouAnySim,
  hasPergunta16ExemplosPassouAnySim,
  isPergunta16ExemplosAllFilled,
  isPergunta16ExemplosAllNao,
} from './utils-consultaSeguimentoPergunta16'

export const validatorConsultaSeguimentoPergunta16 = createValidator<ConsultaSeguimentoPergunta16Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_16_HEADER: required,
  },
  (values: ConsultaSeguimentoPergunta16Model, errors: ErrorObject<ConsultaSeguimentoPergunta16Model>) => {
    if (values?.PERGUNTA_16_HEADER === SimNaoEnum.NAO) {
      const isPerguntaExemplosAllNao = isPergunta16ExemplosAllNao(values?.PERGUNTA_16_EXEMPLOS)
      const isExemplosAllFilled = isPergunta16ExemplosAllFilled(values?.PERGUNTA_16_EXEMPLOS)

      if (!isExemplosAllFilled) {
        errors.PERGUNTA_16_EXEMPLOS = pergunta16ExemplosValidator(values.PERGUNTA_16_EXEMPLOS)
      }

      if (isPerguntaExemplosAllNao) {
        errors.PERGUNTA_16_EXEMPLOS = CONSULTA_SEGUIMENTO_NAO_PARA_TODOS_VALIDATION_MESSAGE
      }

      const hasPerguntaExemplosPassouAnySim = hasPergunta16ExemplosPassouAnySim(values?.PERGUNTA_16_EXEMPLOS)
      const hasPerguntaExemplosFalhouAnySim = hasPergunta16ExemplosFalhouAnySim(values?.PERGUNTA_16_EXEMPLOS)

      if (hasPerguntaExemplosPassouAnySim && hasPerguntaExemplosFalhouAnySim) {
        errors.PERGUNTA_16_FREQUENCIA = required(values?.PERGUNTA_16_FREQUENCIA)
      }
    }
    return errors
  }
)

const pergunta16ExemplosValidator = createValidator<ConsultaSeguimentoPergunta16Model['PERGUNTA_16_EXEMPLOS']>({
  FALHOU: createValidator<ConsultaSeguimentoPergunta16Model['PERGUNTA_16_EXEMPLOS']['FALHOU']>({
    NAO_REPARA_EM_VOCE: required,
    OLHA_PARA_SEU_ROSTO: required,
  }),
  PASSOU: createValidator<ConsultaSeguimentoPergunta16Model['PERGUNTA_16_EXEMPLOS']['PASSOU']>({
    OLHA_PARA_O_QUE_VOCE_ESTA_OLHANDO: required,
    APONTA_PARA_O_QUE_VOCE_ESTA_OLHANDO: required,
    OLHA_AO_REDOR_PARA_O_QUE_VOCE_ESTA_OLHANDO: required,
  }),
})
